import React, { useState, useContext } from "react";
import { Button, Link, TableCell, TableRow } from "@material-ui/core";
import Routes from "../../../constants/Routes";

import SearchAppContext from "../../lib/ApplicationQueue/searchedAppContext";

export default function TableRowData(props) {
	const { app, isStandAlone, onClose } = props;

	const [internalClicked, setInternalClicked] = useState(false);

	const { setSearchedApp, setSearchedQueue } = useContext(SearchAppContext);

	const formatCreditAppExpirationDate = (dateString) => {
		if (dateString) {
			const dateArray = dateString.split("-");
			return `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`;
		}
		return "";
	};

	return (
		<TableRow>
			<TableCell>{app.id ? app.id : app.name ?? ""}</TableCell>
			<TableCell>{app.contract_number ? app.contract_number : ""}</TableCell>
			<TableCell>
				{app.referral_party_application_id ? app.referral_party_application_id : ""}
			</TableCell>
			<TableCell>{app.status ? app.status : ""}</TableCell>
			<TableCell>
				{app.broker_account_name ? app.broker_account_name : ""}
			</TableCell>
			<TableCell>{app.application_state ? app.application_state : ""}</TableCell>
			<TableCell>
				{app.credit_app_expiration_date
					? formatCreditAppExpirationDate(app.credit_app_expiration_date)
					: ""}
			</TableCell>
			<TableCell>{app.applicant_name ? app.applicant_name : ""}</TableCell>
			<TableCell>{app.account_manager_id ? app.account_manager_id : ""}</TableCell>

			<TableCell>
				<Button
					size="sm"
					variant="contained"
					color="primary"
					style={{ textTransform: "capitalize" }}
					disabled={internalClicked}
					onClick={() => {
						setSearchedApp(app);
						setSearchedQueue(app.status);						
						setInternalClicked(true);
						onClose();
					}}>
					View
				</Button>

				{/* 
					<Button
						size="sm"
						variant="contained"
						color="primary"
						style={{ marginLeft: "3px", textTransform: "capitalize" }}>
						<Link
							target="_blank"
							href={Routes.ADMIN_CONSOLE_BY_ID(app.id)}
							style={{ color: "white" }}>
							Admin
						</Link>
					</Button>

			*/}
			</TableCell>
		</TableRow>
	);
}
